export default __webpack_public_path__ + "static/media/upload-photo.7085b35e.svg";